import { graphql } from "react-relay";

export const BUMP_SUBSCRIPTION_VERSION_MUTATION = graphql`
	mutation bumpVersionButton_BumpSubscriptionVersionMutation($offerId: ID!, $toVersion: Int!) {
		Admin {
			Offer {
				bumpSubscriptionVersion(offerId: $offerId, toVersion: $toVersion) {
					kind
					... on BumpBlocked {
						missingElementTypes
					}
				}
			}
		}
	}
`;
